exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointSiteCard_10c4TjOMrvNvt2U95fjYpP{\n  display:flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.IA_sharePointSiteWrapper_2Kq7ong00ANb-pllfSrCh {\n  font-size: 14px;\n  float: left;\n  display: block;\n  width: 100%;\n  padding: 8px 0;\n}\n\n.IA_sharePointSiteId_3bgvRhrB0iZ0p9VkyS2hNe {\n  font-size: 9px;\n  opacity: 0.8\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointSiteCard": "IA_sharePointSiteCard_10c4TjOMrvNvt2U95fjYpP",
	"IA_sharePointSiteWrapper": "IA_sharePointSiteWrapper_2Kq7ong00ANb-pllfSrCh",
	"IA_sharePointSiteId": "IA_sharePointSiteId_3bgvRhrB0iZ0p9VkyS2hNe"
};